// @flow
import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'

import styles from './StaticTextPage.css'
// $FlowIgnore TS import
import RawFormattedMessage from '../components/RawFormattedMessage'

type StaticTextPageProps = {
  translationPrefixKey: string,
  locale: 'en' | 'de'
}

export default class StaticTextPage extends Component<StaticTextPageProps> {
  static async getInitialProps ({
    query: { locale, translationPrefixKey }
  }: {
    query: StaticTextPageProps
  }) {
    return {
      locale,
      disableLinkToHome: true,
      translationPrefixKey
    }
  }

  render () {
    return (
      <article className={styles.root}>
        <header>
          <RawFormattedMessage
            tagName='h4'
            id={`${this.props.translationPrefixKey}.title`}
          />
          <RawFormattedMessage
            tagName='p'
            id={`${this.props.translationPrefixKey}.subtitle`}
          />
        </header>
        <RawFormattedMessage
          isHTML
          id={`${this.props.translationPrefixKey}.summary`}
          className={styles.summary}
          tagName='p'
        />
        <FormattedHTMLMessage
          id={`${this.props.translationPrefixKey}.body`}
          tagName='section'
        />
      </article>
    )
  }
}
